export default {
  category_name: 'Buy gift card',
};
